import React from 'react';

import ToolsBoxWrapper from 'src/containers/ToolsBoxWrapper';
import toolsPropTypes from 'src/types/toolsPropTypes';
import 'src/containers/ToolsContainer.scss';


const { useToolsText, freeToolsText } = {
  useToolsText: 'Skorzystaj z narzędzi',
  freeToolsText: 'Wszystkie narzędzia są bezpłatne'
};

const ToolsContainer = ({ tools }) => (
  <div data-test="section-tools" styleName="tools-container">
    <div styleName="tools">
      <h2 styleName="tools__title">{ useToolsText }</h2>
      <p styleName="tools__subtitle">{ freeToolsText }</p>
      <ToolsBoxWrapper tools={ tools } />
    </div>
  </div>
);

ToolsContainer.propTypes = toolsPropTypes;

export default ToolsContainer;
